import React, { useContext } from 'react'
import styles from './index.module.less'
import classnames from 'classnames'

import context from '../../context'
import { IState } from '../../types'

interface IProps extends IState {
  who?: string
}

export default function Gain(props: IProps) {
  const {
    advantage: { you, friend },
  } = useContext(context)
  const { who, flow } = props
  if (who === 'your') {
    return <h3 className={classnames(styles.gain, styles[flow])}>{you}</h3>
  }
  return <h3 className={classnames(styles.gain, styles[flow])}>{friend}</h3>
}
